import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import Head from '../../helper/Head';
import styles from './AcompanharNumeroFormularioPeticao.module.css';
import { Button, Card, CardContent, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import formularioPeticaoService from './service/formularioPeticao.service';
import { registroDenunciaMascara } from '../../util/util';
import { useTranslation } from 'react-i18next';

export default function AcompanharNumeroFormularioPeticao() {
    const { register, handleSubmit, setValue, setError, clearErrors, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const onSubmit = async (data: any) => {

        const resp = await formularioPeticaoService.getNumeroRegistroFormularioPeticao(data.registroDenuncia);
        
        if (resp.formularioPeticao) {
            navigate('/formulario-peticao/acompanhar-denuncia/resumo/' + resp.formularioPeticao.registroDenuncia);
        } else if (resp.error && !!resp.error.data) {
            setError(resp.error.data[0].label, { message: resp.error.data[0].erro })
            setValue(resp.error.data[0].label, '');
        } else {
            setError('registroDenuncia', { message: "Registro de denúncia inexistente!" })
            setValue('registroDenuncia', '')
        }
    }

    const handleRegistroDenuncia = (e: any) => {
        clearErrors('registroDenuncia');
        setValue('registroDenuncia', registroDenunciaMascara(e.target.value));
    }

    return (
        <section className="background-section background-initial">
            <Head title=" | Acompanhar denúncia" />
            <div className="animeRight container">
                <div className={styles.sectionTitle}>
                    <h1 className={styles.title}>{t('tituloAcompanharDenuncia')}</h1>
                    <h2 className={styles.subtitle}></h2>
                </div>
                <div className={styles.container}>
                    <Card>
                        <CardContent>
                            <span className={styles.formDescription}>
                                {t('textoInformeNumeroRegistroPeticao')}
                            </span>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={styles.row}>
                                    <TextField
                                        {...register('registroDenuncia', { required: false })}
                                        label={t('registroDenuncia')}
                                        variant="outlined"
                                        type='search'
                                        autoFocus
                                        autoComplete='off'
                                        onChange={handleRegistroDenuncia}
                                        inputProps={{ minLength: 13, maxLength: 13 }}
                                        error={errors.registroDenuncia ? true : false}
                                        helperText={errors.registroDenuncia && errors.registroDenuncia.message?.toString()}
                                    />
                                </div>
                                <div className={styles.formButton}>
                                    <Button onClick={() => navigate(-1)}>
                                        <ArrowBackIcon sx={{ fontSize: 30 }} />
                                    </Button>
                                    <Button variant="contained" type='submit'>
                                        {t('buttomBuscar')}
                                    </Button>
                                </div>
                            </form>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </section>
    )
}